import { array, boolean, number, object, string } from 'yup';
import { isValidPhoneNumber, parsePhoneNumberWithError } from 'libphonenumber-js';

export const excelInvestorSchema = array(
	object({
		firstName: string().min(1),
		lastName: string().min(1),
		email: string().email(),
		isEligibleForNewInvestmentWorkflow: boolean().isTrue(),
		securities: array(
			object({
				number: number().min(1),
				cost: number().min(1),
				name: string().min(1),
				securityId: string().min(1),
			})
		),
		loans: array(
			object({
				amount: number().min(0),
				name: string().min(1),
				loanDefinitionId: string().min(1),
			})
		),
	})
);

export const excelLeaverInvestorSchema = array(
	object({
		firstName: string().min(1),
		lastName: string().min(1),
		email: string().email(),
		isEligibleForNewInvestmentWorkflow: boolean().isTrue(),
		securities: array(
			object({
				currentHoldings: number(),
				totalNumber: number().test(
					'not more than currentHoldings',
					(number, schemaContext) =>
						!!number && number <= schemaContext.parent.currentHoldings
				),
				totalCost: number().test(
					'should be more that 0 if number provided',
					(cost, schemaContext) =>
						schemaContext.parent.number > 0 ? !!cost && cost > 0 : true
				),
				name: string().min(1),
				securityId: string().min(1),
				type: string().min(1),
			})
		).min(1),
		loans: array(
			object({
				amountRemaining: number().min(0).nullable(),
				amount: number().min(1),
				name: string().min(1),
				type: string().min(1),
				loanDefinitionId: string().min(1),
			})
		),
	})
).min(1);

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const isValidEmail = (value: string): boolean => EMAIL_REGEX.test(value.trim());

export const isPhoneValid = (phone: string) => {
	try {
		const parsedPhoneNumber = parsePhoneNumberWithError(phone);
		const isValid = isValidPhoneNumber(phone, {
			defaultCountry: parsedPhoneNumber?.country,
		});
		return isValid;
	} catch {
		return false;
	}
};
